import React from 'react';

import type { ColorChangeHandler } from 'react-color';
import { Hue, Saturation } from 'react-color/lib/components/common';
import tinycolor from 'tinycolor2';

import { useAnalyticsEvents } from '@atlaskit/analytics-next';
// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
import { Box, xcss } from '@atlaskit/primitives';
import { token } from '@atlaskit/tokens';

type HueAndSaturationProps = {
	analyticsSource?: string;
	onChange(color: string): void;
	value: ReturnType<typeof tinycolor>;
};

const saturationStyles = xcss({
	cursor: 'pointer',
	height: '137px',
	position: 'relative',
	width: '100%',
});

const hueStyles = xcss({
	cursor: 'pointer',
	height: '8px',
	position: 'relative',
	width: '100%',
});

export const HueAndSaturation = ({ analyticsSource, value, onChange }: HueAndSaturationProps) => {
	const { createAnalyticsEvent } = useAnalyticsEvents();
	const hsl = value.toHsl();
	const hsv = value.toHsv();

	const onHueOrSaturationChange: ColorChangeHandler = (color) => {
		onChange(tinycolor(color).toHexString());
		createAnalyticsEvent({
			type: 'sendUIEvent',
			data: {
				action: 'clicked',
				actionSubject: 'CustomColor',
				actionSubjectId: 'customPalette',
				source: analyticsSource,
			},
		}).fire();
	};

	return (
		<>
			<Box xcss={saturationStyles}>
				<Saturation
					hsl={hsl}
					hsv={hsv}
					onChange={onHueOrSaturationChange}
					pointer={EllipsePointer}
					radius="4px"
				/>
			</Box>
			<Box xcss={hueStyles}>
				<Hue
					direction="horizontal"
					hsl={hsl}
					onChange={onHueOrSaturationChange}
					pointer={EllipsePointer}
					radius="100px"
				/>
			</Box>
		</>
	);
};

const pointerStyles = xcss({
	border: `${token('border.width.selected')} solid white`,
	borderRadius: 'radius.full',
	cursor: 'pointer',
	height: '8px',
	width: '8px',
});

const EllipsePointer = () => <Box xcss={pointerStyles} />;
